import Quotation from "trade/views/quotation/index.vue";

const routes = [
  {
    path: "/",
    name: "index",
    component: () => import("trade/views/trade/instant.vue")
  },
  {
    path: "/atm",
    name: "atm",
    component: () => import("trade/views/trade/instant.vue")
  },
  {
    path: "/strategy/auto",
    name: "auto",
    component: () => import("trade/views/trade/auto.vue")
  },
  {
    path: "/strategy/instant",
    name: "instant",
    component: () => import("trade/views/trade/instant.vue")
  },
  {
    path: "/fiat",
    name: "fiat",
    component: () => import("trade/views/fiat/index.vue")
  },
  {
    path: "/fiat/wyre",
    name: "fiat-wyre",
    component: () => import("trade/views/fiat/wyre.vue")
  },
  {
    path: "/fiat/hfox",
    name: "fiat-hfox",
    component: () => import("trade/views/fiat/hfox.vue")
  },
  {
    path: "/convert/usdt",
    name: "convert-usdt",
    component: () => import("trade/views/trade/convert_usdt.vue")
  },
  {
    path: "/quotation",
    name: "quotation",
    component: Quotation
  },
  {
    path: "/orders/:id",
    name: "orders-id",
    component: () => import("trade/views/orders/_id.vue")
  },
  {
    path: "/orders/wyre/:id",
    name: "orders-wyre-id",
    component: () => import("trade/views/orders/_wyre_id.vue")
  },
  {
    path: "/orders",
    name: "orders",
    component: () => import("trade/views/orders/index.vue")
  }
];

export default routes;
